// Add TypeScript declaration
declare global {
    interface Window {
        __derOfServiceWorker?: boolean;
    }
}
window.__derOfServiceWorker = false;
export async function deregOfServiceWorker(){
    if(window.__derOfServiceWorker) return;
    window.__derOfServiceWorker = true;
    let displayCacheLog = false;
    try {
        displayCacheLog = process.env.SHOW_CACHE_LOG
            ? JSON.parse(process.env.SHOW_CACHE_LOG.toLowerCase())
            : false;
    } catch (error) {
        displayCacheLog = false;
    }

    const registrations = await navigator.serviceWorker.getRegistrations();
    if(displayCacheLog) 
        console.log(`%c[SW]%c Found ${registrations.length} service worker registrations:`,'background:blue; color:#f3f3f3; font-weight: bold; padding: 0 8px', '');
    
    for (let index = 0; index < registrations.length; index++) {
        const registration = registrations[index];
        if(displayCacheLog){
            console.log(`%c[SW]%c Registration ${index + 1}:`,'background:blue; color:#f3f3f3; font-weight: bold; padding: 0 8px', '');
            console.log(`%c[SW]%c - Scope: ${registration.scope}`,'background:blue; color:#f3f3f3; font-weight: bold; padding: 0 8px', '');
            console.log(`%c[SW]%c - Active: ${registration.active ? registration.active.scriptURL : 'None'}`,'background:blue; color:#f3f3f3; font-weight: bold; padding: 0 8px', '');
            console.log(`%c[SW]%c - Installing: ${registration.installing ? registration.installing.scriptURL : 'None'}`,'background:blue; color:#f3f3f3; font-weight: bold; padding: 0 8px', '');
            console.log(`%c[SW]%c - Waiting: ${registration.waiting ? registration.waiting.scriptURL : 'None'}`,'background:blue; color:#f3f3f3; font-weight: bold; padding: 0 8px', '');
        }
        if (registration) {
            // Check if the service worker is 'sw1'
            const isSw1 = registration.active && 
                          registration.active.scriptURL && 
                          registration.active.scriptURL.includes('sw1.js');
            
            if (isSw1) {
                await registration.unregister();
                if (displayCacheLog) console.log('%c[SW]%c Service worker sw1 unregistered','background:green; color:#f3f3f3; font-weight: bold; padding: 0 8px', '');
            }
        }
    }
}
